import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { CompletionMessageComponent } from '@shared/components/completion-message/completion-message.component';
import { LinxStatus, REQUEST_UNAVAILABLE_MESSAGE } from '@shared/constants/app-constants';
import { WorkflowService } from '@shared/services';

@Component({
  selector: 'app-capture-send-inactive-request',
  templateUrl: './inactive-request.component.html',
  standalone: true,
  imports: [CompletionMessageComponent],
  styles: [
    `
      :host {
        width: 100%;
      }
    `,
  ],
})
export class InactiveRequestComponent implements OnInit {
  errorCode!: string;
  imgUrl = '';

  // The workflow finished: show the "you're all set" layout (KOR-15211). DECLINED shares the completed copy below but is
  // not a completion, so it keeps the plain status screen.
  isCompletion = false;

  message: Record<string, string> = {
    request_completed: 'Request has already completed.',
    request_error: REQUEST_UNAVAILABLE_MESSAGE,
    request_expired: 'This link is no longer active, and we cannot proceed at this time.',
    request_declined: 'Request successfully Declined.',
  };

  constructor(
    private route: Router,
    private workflowService: WorkflowService,
  ) {}

  ngOnInit(): void {
    this.setStatus();
  }

  private setStatus(): void {
    const errorResopnse = history?.state?.error;
    if (!errorResopnse) {
      this.route.navigate(['404']);
      return;
    }

    if (errorResopnse === LinxStatus.SYSTEM_MAINTENANCE) {
      this.route.navigate(['/maintenance']);
      return;
    }

    this.isCompletion = errorResopnse === LinxStatus.SUCCESS || errorResopnse === LinxStatus.COMPLETED;
    if (this.isCompletion) {
      return;
    }

    switch (errorResopnse) {
      case LinxStatus.EXPIRED:
        this.errorCode = 'request_expired';
        break;

      case LinxStatus.DECLINED:
        this.errorCode = 'request_completed';
        break;

      case LinxStatus.FAILED:
        // The business name is only known once the workflow details have loaded; without it, keep the generic copy.
        if (this.workflowService.businessName) {
          this.message.request_error = `We are unable to proceed at this time. Please contact ${this.workflowService.businessName} for further action.`;
        }
        this.errorCode = 'request_error';
        break;

      case LinxStatus.REQUEST_DECLINED:
        this.errorCode = 'request_declined';
        break;
      case LinxStatus.CANCELLED:
        this.errorCode = 'request_expired';
        break;
      default:
        this.errorCode = 'request_error';
        break;
    }
    this.imgUrl = `assets/images/${this.errorCode}.svg`;
  }
}
